var _TranslationLoader_translationPackFns;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { Injectable } from "@angular/core";
import { Logger } from "@smallstack/core-common";
import { TranslationStore } from "../stores/translation.store";
import * as i0 from "@angular/core";
import * as i1 from "../stores/translation.store";
export class TranslationLoader {
    constructor(translationStore) {
        this.translationStore = translationStore;
        _TranslationLoader_translationPackFns.set(this, void 0);
    }
    register(translationPackFns) {
        __classPrivateFieldSet(this, _TranslationLoader_translationPackFns, translationPackFns, "f");
    }
    async load(locale) {
        if (!__classPrivateFieldGet(this, _TranslationLoader_translationPackFns, "f")) {
            Logger.warning("TranslationLoader", "Please call register() before calling load().");
            return;
        }
        for (const translationPackFn of __classPrivateFieldGet(this, _TranslationLoader_translationPackFns, "f")) {
            const translationPack = await translationPackFn(locale);
            this.translationStore.addTranslationPack(locale, translationPack);
        }
    }
}
_TranslationLoader_translationPackFns = new WeakMap();
TranslationLoader.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: TranslationLoader, deps: [{ token: i1.TranslationStore }], target: i0.ɵɵFactoryTarget.Injectable });
TranslationLoader.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: TranslationLoader });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: TranslationLoader, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.TranslationStore }]; } });
